import { ADD_INSIGHTS_FORM_CHANGES } from '../../Redux.constants';

export function addInsightsFormChangeAction(params) {
    return (dispatch) => {
        dispatch({
            type: ADD_INSIGHTS_FORM_CHANGES,
            payload: params,
        });
    };
}